export enum Overlay {
  screen = 'screen',
  parent = 'parent',
}
